import { render } from "./SimpleCollapsibleSection.vue?vue&type=template&id=8c7fa50e&scoped=true"
import script from "./SimpleCollapsibleSection.vue?vue&type=script&lang=js"
export * from "./SimpleCollapsibleSection.vue?vue&type=script&lang=js"

import "./SimpleCollapsibleSection.vue?vue&type=style&index=0&id=8c7fa50e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7fa50e"]])

export default __exports__